<template>
  <v-card style="height:400px; gap:20px">
    <v-card-title>
      <router-link to="/memos" style="text-decoration: none;" class="black--text cursor-pointer">Latest Memos</router-link>
      <v-icon class="ml-1" v-if="!loading" @click="getItems()">mdi-refresh</v-icon>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        prepend-inner-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        dense
        class="mt-0 pt-0"
        @keyup.enter="getItems"
        append-icon="mdi-close"
        @click:append="(search = null), getItems()"
      ></v-text-field>
    </v-card-title>

    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>

    <v-card-text>
      <v-simple-table v-if="memos.length" style="height: 280px; overflow: auto;">
        <thead>
          <tr class="text-uppercase">
            <!-- <th style="width:1px">#</th> -->
            <th width="130px">Date</th>
            <th width="120px">Memo #</th>
            <th>From</th>
            <!-- <th>To</th> -->
            <th>Title</th>
            <th style="width:1px"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in memos" :key="item.id">
            <!-- <td class="grey--text">{{ item.id }}</td> -->
            <td>{{ $localeDate(item.memo_date) }}</td>
            <td>{{ item.ref_number }}</td>
            <td>{{ item.sender_unit ? item.sender_unit.cEngUnitName : (item.sender_section ? item.sender_section.cEngSectionName : '') }}</td>
            <!-- <td>{{ item.recipent_unit ? item.recipient_unit.cEngUnitName : 'All Staff' }}</td> -->
            <td class="dhivehi">
              <bdi>
                {{ item.title }}
              </bdi>
            </td>
            <td>
              <!-- <v-icon v-if="item.document && item.document.file" @click="viewFile(item)" color="red darken-2">mdi-file-pdf-box</v-icon> -->
              <v-icon @click="$refs.viewMemoModal.open(item.id)" color="blue darken-2">mdi-open-in-new</v-icon>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      
      <div v-if="!loading && !memos.length" class="text-center grey--text">
        No memos..
      </div>
      <!-- <v-pagination v-if="memos.length" :total="total" :length="pages" @input="changePage" :value="$route.query.page ? parseInt($route.query.page) : 1"></v-pagination> -->

      <view-pdf-modal ref="pdfModal"></view-pdf-modal>
      <view-memo-modal ref="viewMemoModal"></view-memo-modal>
    </v-card-text>
  </v-card>
</template>

<script>
import ViewMemoModal from '../memos/ViewMemoModal.vue'
// import Multiselect from 'vue-multiselect'
import ViewPdfModal from '../util/ViewPdfModal.vue'

export default {
  components: {
    ViewPdfModal,
    // Multiselect,
    ViewMemoModal
  },
  data () {
    return {
      search: '',
      loading: false,
      // pages: 1,
      total: 0,
      memos: [],

    }
  },

  methods: {
    getItems(){
      let params = {
        // page: this.$route.query.page ?? 1,
        limit: 5,
        search: this.search ? this.search : null
      }
      this.loading = true
      return this.$axios.get(`/api/memos/list/to`, {params}).then(res => {
        this.memos = res.data.data
        // this.pages = res.data.last_page,
        // this.total = res.data.total
      }).finally(() => this.loading = false)
    },
    // changePage(val){
    //   this.$router.push({query: { ...this.$route.query, page: val}})
    //   this.getItems()
    // },
    viewFile(item){
      this.$refs.pdfModal?.open(item.document.file.url, 'Memo '+item.ref_number)
    }
  },
  mounted(){
    this.getItems()
  }
}
</script>